// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_UG9","cls2":"AuthorHeader-cls2_XxA AuthorHeader-cls1_UG9"};